import dayjs from 'dayjs';
import type {Event} from '../entities/Event';

/** Days until the event ends, counting the last day (negative once the event is over). */
export function remainingDays(event: Event): number {
  return dayjs(event.end).diff(dayjs(), 'day') + 1;
}
